import React, { useEffect, useState } from "react";
import { getApiData } from "../../services/index";
import "./index.css";
import Naati3 from "../../assets/Naati3.jpg";

const NAATI = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [coachings, setCoachings] = useState([]);
  const [contentLoaded, setContentLoaded] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getApiData("api/get_naati_ccl", {});
      if (result && result.status === 200) {
        const filteredCoachings = result.data.filter(
          (coaching) => coaching.slug === "NAATI"
        );
        setCoachings(filteredCoachings);
        setContentLoaded(true);
      }
    };
    fetchData();
  }, []);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const items = [
    {
      title: "Tried and Tested Strategies",
      detail:
        "Proven exam techniques to help you improve interpretation skills, manage time effectively, and avoid common mistakes.",
    },
    {
      title: "Note-Taking Skills",
      detail:
        "Effective note-taking is essential for accurate and efficient interpretation in the NAATI CCL test.At Language Coaching College, we train students in structured note- taking techniques to help them retain key information and deliver precise translations.",
    },
    {
      title: "Practice Workshops",
      detail:
        "Interactive sessions designed to simulate real exam dialogues, providing hands-on experience with expert guidance.",
    },
    {
      title: "Practice Material",
      detail:
        "Comprehensive NAATI CCL study resources, including mock dialogues, vocabulary lists, and sample test scenarios.",
    },
    {
      title: "Feedback Sessions",
      detail:
        "Personalized feedback to analyse strengths and weaknesses, ensuring continuous improvement in language skills.",
    },
    {
      title: "Mock Test",
      detail:
        "Experience a one-on-one mock test designed to simulate the real exam environment, helping you build confidence and improve performance under exam conditions.",
    },
    {
      title: "Grammar Classes",
      detail:
        "Specialized grammar sessions to strengthen your foundation, refine sentence structure,and eliminate common errors.",
    },
    {
      title: "Motivated Professionals Helping You Get Your Score",
      detail:
        "A team of expert trainers dedicated to guiding and supporting you to achieve your desired NAATI CCL score.",
    },
  ];
  return (
    <>
      {/* main section */}
      <div className="py-12 px-4 lg:px-8">
        {contentLoaded ? (
          <section>
            <h1 className="main-display text-center mt-8">NAATI CCL</h1>
          </section>
        ) : (
          <p className="text-center mt-8">Data loading...</p>
        )}

        <section className="p-4 max-w-7xl mx-auto">
          {/* Hero Section */}
          {coachings.length > 0 &&
            coachings.map((coaching, index) => (
              <div className="mt-12 bg-color rounded-md">
                <div className="container">
                  <div className="cta-grid">
                    {/* Left Content Updated */}
                    <div id="w-node-_86b659df-b93d-dfa6-9d4f-1ba273b772a1-b3f3b9f1">
                      <div
                        className="flex-tag left"
                        style={{
                          opacity: 1,
                          transform:
                            "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                        }}
                      >
                        <div className="bullet-tag color"></div>
                      </div>

                      <h2>{coaching.why_title}</h2>

                      <ul
                        className="list-disc her"
                        dangerouslySetInnerHTML={{
                          __html: coaching.why_desc,
                        }}
                      ></ul>

                      <a
                        href="https://languagecoachingcollege.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block"
                      >
                        <button className="flex items-center justify-center text-center subhead py-2 px-4 sm:px-6 md:px-8 lg:px-10 bg-[#4BBA89] hover:bg-[#1D2E63] transition-all duration-300 ease-in-out rounded-lg mt-2 sm:mt-3 text-white sm:text-base leading-snug shadow-md hover:shadow-lg sm:whitespace-normal">
                          Ready to start&nbsp;
                          <span className="text-xs sm:text-base">
                            your NAATI CCL journey!!
                          </span>
                        </button>
                      </a>

                      <div className="margin-50px"></div>
                    </div>

                    {/* Right Image */}
                    <div id="w-node-d44cd5a9-f968-a640-bb6d-b50b5f3db574-4b337b90">
                      <div className="image-wrapper image-wrapper9">
                        <img
                          src={coaching.why_img} // Adjust the path based on your project structure
                          loading="eager"
                          alt="NAATI Img1"
                          className="cover-animated-image5 w-full h-auto"
                          sizes="(max-width: 479px) 100vw, (max-width: 767px) 80vw, (max-width: 991px) 70vw, 650px"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

          {/* what Section in Between */}
          {coachings.length > 0 &&
            coachings.map((coaching, index) => (
              <section className="lg:mt-12">
                <div className="lg:text-center max-w-3xl mx-auto">
                  <h2>{coaching.what_title}</h2>
                  <p
                    className="subhead"
                    dangerouslySetInnerHTML={{ __html: coaching.what_desc }}
                  ></p>
                </div>
              </section>
            ))}

          {/* test format */}
          {coachings.length > 0 &&
            coachings.map((coaching, index) => (
              <div className="mt-12 bg-color rounded-md">
                <div className="container">
                  <div className="cta-grid">
                    {/* Left Content Updated */}
                    <div id="w-node-_86b659df-b93d-dfa6-9d4f-1ba273b772a1-b3f3b9f1">
                      <div
                        className="flex-tag left"
                        style={{
                          opacity: 1,
                          transform:
                            "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                        }}
                      >
                        <div className="bullet-tag color"></div>
                      </div>

                      <h2>{coaching.test_title}</h2>

                      <p
                        className="subhead sm:mt-5 text-justify"
                        dangerouslySetInnerHTML={{ __html: coaching.test_desc }}
                      ></p>

                      <div className="margin-50px"></div>
                    </div>

                    {/* Right Image */}
                    <div id="w-node-d44cd5a9-f968-a640-bb6d-b50b5f3db574-4b337b90">
                      <div className="image-wrapper image-wrapper9">
                        <img
                          src={coaching.test_img} // Adjust the path based on your project structure
                          loading="eager"
                          alt="NAATI Img2"
                          className="cover-animated-image5 w-full h-auto image-desktop-right-2"
                          sizes="(max-width: 479px) 100vw, (max-width: 767px) 80vw, (max-width: 991px) 70vw, 650px"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

          {/* Next Section */}
          {contentLoaded && (
            <div className="">
              <div className="container" style={{ zIndex: 0 }}>
                <div className="text-center lg:mt-16 sm:mt-8">
                  <h2>
                    What is included in the{" "}
                    <span style={{ color: "#4BBA89" }}>NAATI CCL</span> Course?
                  </h2>
                  <p className="subhead">
                    We offer the highest quality training with experts who care.
                    Our courses include:
                  </p>
                </div>

                <div className="bg-color rounded-md mt-8">
                  <div className="container" style={{ zIndex: 0 }}>
                    <div className="ceo-grid-2 no-gap ceo-grid-2-pte">
                      <div id="w-node-d44cd5a9-f968-a640-bb6d-b50b5f3db574-4b337b90">
                        <img
                          src={Naati3}
                          loading="eager"
                          alt="NAATI img3"
                          className="cover-animated-image cover-animated-image-part2 cover-animated-mobile-IELTS img-IETLS w-full h-auto"
                          sizes="(max-width: 479px) 100vw, (max-width: 767px) 80vw, (max-width: 991px) 70vw, 650px"
                        />
                      </div>
                      <div id="w-node-d44cd5a9-f968-a640-bb6d-b50b5f3db578-4b337b90">
                        <div className="flex-tag left">
                          <div className="bullet-tag"></div>
                        </div>
                        <div className="subhead flex flex-col sm:flex-row items-start justify-between gap-6 p-4 rounded-lg text-gray-800">
                          {[0, 1].map((colIndex) => (
                            <div
                              key={colIndex}
                              className="w-full sm:w-1/2 space-y-2"
                            >
                              {items
                                .slice(colIndex * 4, colIndex * 4 + 4)
                                .map((item, index) => (
                                  <div
                                    key={index}
                                    className="bg-white shadow-lg rounded-lg"
                                  >
                                    <button
                                      className="w-full text-left p-4 focus:outline-none focus:ring-2 focus:ring-[#4BBA89] flex justify-between items-center rounded-lg"
                                      onClick={() =>
                                        toggleAccordion(colIndex * 4 + index)
                                      }
                                    >
                                      <p
                                        className="subhead"
                                        style={{ marginBottom: "0px" }}
                                      >
                                        {item.title}
                                      </p>
                                      <span>
                                        {activeIndex === colIndex * 4 + index
                                          ? "−"
                                          : "+"}
                                      </span>
                                    </button>
                                    {activeIndex === colIndex * 4 + index && (
                                      <p className="subhead p-2">
                                        {item.detail}
                                      </p>
                                    )}
                                  </div>
                                ))}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* section 1-test assested */}
          {coachings.length > 0 &&
            coachings.map((coaching, index) => (
              <div className="mt-12 bg-color rounded-md">
                <div className="container ">
                  <div className="cta-grid">
                    {/* Left Content Updated */}
                    <div id="w-node-_86b659df-b93d-dfa6-9d4f-1ba273b772a1-b3f3b9f1">
                      <div
                        className="flex-tag left"
                        style={{
                          opacity: 1,
                          transform:
                            "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                        }}
                      >
                        <div className="bullet-tag color"></div>
                      </div>
                      <div className="lg:mr-[44px]">
                        <h2>{coaching.section1_title}</h2>
                        <p
                          className="subhead sm:mt-5 text-justify"
                          dangerouslySetInnerHTML={{
                            __html: coaching.section1_desc,
                          }}
                        ></p>
                      </div>

                      <div className="margin-50px"></div>
                    </div>

                    {/* Right Image */}
                    <div id="w-node-d44cd5a9-f968-a640-bb6d-b50b5f3db574-4b337b90">
                      <div className="image-wrapper image-wrapper9">
                        <img
                          src={coaching.section1_img} // Adjust the path based on your project structure
                          loading="eager"
                          alt="NAATI Img4"
                          className="cover-animated-image5 w-full h-auto"
                          sizes="(max-width: 479px) 100vw, (max-width: 767px) 80vw, (max-width: 991px) 70vw, 650px"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

          {/* Section 2 */}
          {coachings.length > 0 &&
            coachings.map((coaching, index) => (
              <div className="lg:p-8">
                <div className="container" style={{ zIndex: 0 }}>
                  <div className="ceo-grid-2 no-gap">
                    {/* Left Image */}
                    <div id="w-node-d44cd5a9-f968-a640-bb6d-b50b5f3db574-4b337b90">
                      <div className="">
                        <img
                          src={coaching.section2_img}
                          loading="eager"
                          alt="NAATI Img5"
                          className="cover-animated-image cover-animated-image10 cover-animated-mobile w-full h-auto"
                          sizes="(max-width: 479px) 100vw, (max-width: 767px) 80vw, (max-width: 991px) 70vw, 650px"
                        />
                      </div>
                    </div>

                    {/* Right Content Updated */}
                    <div
                      id="w-node-d44cd5a9-f968-a640-bb6d-b50b5f3db578-4b337b90"
                      className=""
                    >
                      <div className="flex-tag left">
                        <div className="bullet-tag"></div>
                      </div>

                      <div
                        className="subhead text-2xl font-semibold text-gray-800 xtra-width"
                        dangerouslySetInnerHTML={{
                          __html: coaching.section2_desc,
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </section>

        {/* section 3 */}
        {coachings.length > 0 &&
          coachings.map((coaching, index) => (
            <section className="bg-white lg:p-8">
              <div className="container px-4 bg-color rounded-md">
                <div className="flex flex-col lg:flex-row gap-[4rem] place-items-center">
                  {/* Left Column */}
                  <div className="w-full lg:w-1/2">
                    <div className="mb-8">
                      <h2 className="mb-4">{coaching.section3_left_title1}</h2>
                      <p
                        className="mb-4 subhead text-justify"
                        dangerouslySetInnerHTML={{
                          __html: coaching.section3_left_desc1,
                        }}
                      ></p>
                    </div>

                    <div>
                      <h2 className="mb-4">{coaching.section3_left_title2}</h2>
                      <p
                        className="mb-4 subhead text-justify"
                        dangerouslySetInnerHTML={{
                          __html: coaching.section3_left_desc2,
                        }}
                      ></p>
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="w-full lg:w-1/2">
                    <div className="bg-[#4BBA89] p-4 text-white rounded-lg shadow-lg passmark">
                      <p
                        className="mb-4 subhead text-white text-justify"
                        dangerouslySetInnerHTML={{
                          __html: coaching.section3_right_desc,
                        }}
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ))}

        <div className="border-t border-gray-300 my-4"></div>

        {/* last section*/}
        {coachings.length > 0 &&
          coachings.map((coaching, index) => (
            <section className="py-6">
              <div className="max-w-3xl mx-auto text-center">
                <h4
                  dangerouslySetInnerHTML={{
                    __html: coaching.last_section.replace(/<\/?p>/g, ""),
                  }}
                />
              </div>
            </section>
          ))}

        <div className="border-t border-gray-300 my-4"></div>
      </div>
    </>
  );
};

export default NAATI;
